import { Component, OnInit } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { UnespCoreMessageService } from '@unesp/core'
import { CargaHoraria } from 'src/app/models/carga-horaria'
import { CargaHorariaCompleto } from 'src/app/models/carga-horaria-completo'
import { DocenteService } from 'src/app/services/docente-service'

@Component({
  selector: 'app-docente-aprovar-carga-horaria-efetiva',
  templateUrl: './docente-aprovar-carga-horaria-efetiva.component.html',
  styleUrls: ['./docente-aprovar-carga-horaria-efetiva.component.css'],
  standalone: false
})
export class DocenteAprovarCargaHorariaEfetivaComponent implements OnInit {
  colunasGrid: string[] = ['idItemPlano', 'descricaoItemPlano', 'cargaHorariaPrevista', 'cargaHorariaEfetiva']
  dataSource: MatTableDataSource<CargaHoraria> = new MatTableDataSource()

  id: number = 0
  data?: CargaHorariaCompleto

  constructor(
    private route: ActivatedRoute,
    private docenteService: DocenteService,
    private unespCoreMessageService: UnespCoreMessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id']
      this.docenteService.cargaHorariaEfetiva(this.id).subscribe({
        next: data => {
          this.data = data
          this.dataSource = new MatTableDataSource(data.plano)
        },
        error: err => {
          err.error.message
            ? this.unespCoreMessageService.showMessageError(err.error.message)
            : this.unespCoreMessageService.showMessageError(err.message)
          this.router.navigate(['/docente/aprovar-carga-horaria'])
        },
      })
    })
  }

  gravar(): void {
    this.docenteService.registrarCargaHorariaEfetiva(this.id, this.dataSource.data).subscribe(data => {
      if (data.status === 'ok') {
        this.unespCoreMessageService.showMessageSuccess(`Carga horária registrado com sucesso`)
        this.router.navigate(['/docente/aprovar-carga-horaria'])
      } else {
        this.unespCoreMessageService.showMessageError(data.message)
      }
    })
  }
}
